import React, { useEffect, useState } from "react";

import { FaCirclePlus, FaRetweet, } from "react-icons/fa6";
import { FiDownload } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";

import { exportToExcel } from 'react-json-to-excel';
import MonthYearPicker from "../../../../../components/Input/MonthYearPicker";
import { BrComerceApiService } from "../../../../../services/BrComerceApiService";
import store from "../../../../../store/store";
import Loading from "../../../../home/components/Loading";
import Container from "../../../components/Container";
import styles from "./reports.module.scss";
import imgOwnDeliveryReports from "../../../../../assets/images/own_delivery_reports.svg";
import InputSelect from "../../../../../components/InputSelect";
import DatePicker from "../../../../../components/Input/DatePicker";
import DeliveryTypeEnum from "../../../../../enums/DeliveryTypeEnum";
import { addDays, endOfMonth, format } from "date-fns";
import moment from "moment";
import InputSelectAsync from "../../../../../components/InputSelectAsync";
import { hasPermission } from "../../../../../helpers/permissions";
import AdminPermissionEnum from "../../../../../enums/AdminPermissionEnum";

const tableTypes = {
  normal: "normal",
  delivered: "delivered",
  notDelivered: "notDelivered",
  validated: "validated",
}

const tableOptions = [
  {
    value: tableTypes.normal,
    label: "Objetos Faturados",
  },
  {
    value: tableTypes.validated,
    label: "Objetos Expedidos",
  },
  {
    value: tableTypes.delivered,
    label: "Entregas realizadas",
  },
  {
    value: tableTypes.notDelivered,
    label: "Entregas não realizadas",
  },
]

const deliveryTypesOptions = [
  {
    value: DeliveryTypeEnum.OWN_DELIVERY,
    label: "Super Expresso",
  },
  {
    value: DeliveryTypeEnum.ULTRA,
    label: "Ultra Expresso",
  },
]

const OwnDeliveryReports = () => {
  const { auth } = store.getState();
  const { user } = auth;
  const history = useHistory();

  useEffect(() => {
    if (!hasPermission(AdminPermissionEnum.VIEW_FINANCIAL)) {
      history.push("/");
    }
  }, [history]);

  const api = new BrComerceApiService();

  const [loading, setLoading] = useState(false);
  const [reportType, setReportType] = useState(null);
  const [deliveryType, setDeliveryType] = useState({ value: DeliveryTypeEnum.OWN_DELIVERY, label: "Super Expresso" });
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [showMonthYearPicker, setShowMonthYearPicker] = useState(true)
  const [ownDeliveryReports, setOwnDeliveryReports] = useState([]);
  const [displaySuperExpressItems, setDisplaySuperExpressItems] = useState([]);
  const [displayImg, setDisplayImg] = useState(true);
  const [searchClient, setSearchClient] = useState(null);


  useEffect(() => {
    window.setPageTitle("Relatórios - Entrega Própria");

    if (user.profile !== "admin") {
      history.push("/");
    }
  }, []);

  useEffect(() => {
    setDisplayImg(true);
    setOwnDeliveryReports([]);
    setDisplaySuperExpressItems([]);
  }, [reportType]);

  useEffect(() => {
    setDisplayImg(true);
    setOwnDeliveryReports([]);
    setDisplaySuperExpressItems([]);
  }, [deliveryType]);

  const handleOnChangeCalendarPeriod = e => {
    const inicio = e.dateStart ? e.dateStart?.split("/") :
      e.length ? e[0]?.split("/") : undefined;
    const fim = e.dateEnd ? e.dateEnd?.split("/") :
      e.length ? e[1]?.split("/") : undefined;

    if (inicio && fim) {
      setStartDate(
        new Date(Number(inicio[2]), Number(inicio[1] - 1), Number(inicio[0]))
      );
      setEndDate(
        new Date(Number(fim[2]), Number(fim[1] - 1), Number(fim[0]))
      );
    }

    if (e?.split("/")?.length) {
      const date = e.split("/");
      setStartDate(new Date(Number(date[1]), Number(date[0] - 1), 1));
      setEndDate(endOfMonth(new Date(Number(date[1]), Number(date[0] - 1))));
    }
  };

  const loadOwnDeliveryReports = async () => {
    try {
      setLoading(true);
      const response = await api.makeHttpRequest({
        url: `/reports?startDate=${moment(startDate).format("yyyy-MM-DD")}&endDate=${moment(addDays(endDate, 1)).format("yyyy-MM-DD")}&type=${reportType}&deliveryType=${deliveryType.value}&userId=${searchClient?.value || ""} `,
      });

      setOwnDeliveryReports(response);
      setDisplaySuperExpressItems(response?.slice(0, 100))
    } catch (e) {
      Swal.fire({
        text: "Erro ao carregar lista de envios",
        title: "Relatórios - Entrega Própria",
        icon: "error"
      });
    } finally {
      setLoading(false);
      setDisplayImg(false);
    }
  }

  const getNameOfReportFile = () => {
    if (isNormal) {
      return `Relatório ${deliveryType.label} - ${showMonthYearPicker ? `${format(startDate, "MM-yyyy")}` : `${format(startDate, "dd-MM-yyyy")} - ${format(endDate, "dd-MM-yyyy")}`}`;
    } else {
      const type = reportType === tableTypes.delivered
        ? "Entregas Realizadas"
        : reportType === tableTypes.validated
          ? "Entregas Validadas"
          : "Entregas Não Realizadas"
      return `Relatório ${deliveryType.label} - ${type} - ${showMonthYearPicker ? `${format(startDate, "MM-yyyy")}` : `${format(startDate, "dd-MM-yyyy")} - ${format(endDate, "dd-MM-yyyy")}`}`
    }
  }

  const handleClearPeriodFilter = () => {
    setStartDate("");
    setEndDate("");
  };

  const isNormal = reportType === tableTypes.normal
  const isValidated = reportType === tableTypes.validated

  return (
    <>
      <Loading isLoading={loading} />
      <Container title="Relatórios - Entrega Própria">
        <div className={styles.contentBody}>
          <div className={styles.filters}>
            <div className={styles.filterSelect}>
              <InputSelectAsync
                search={searchClient}
                setSearch={setSearchClient}
              />
            </div>
          </div>

          <div className={styles.filters}>

            <div className={styles.filterSelect}>
              <InputSelect
                id="package-filter"
                options={tableOptions}
                value={tableOptions.find((option) => option.value === reportType) || null}
                onChange={(selectedOption) => setReportType(selectedOption?.value || null)}
                placeholder="Tipo de relatório"
              />
            </div>

            <div className={styles.filterSelect}>
              <InputSelect
                options={deliveryTypesOptions}
                value={deliveryType.value}
                onChange={(selectedOption) => setDeliveryType(selectedOption)}
                placeholder={deliveryType.label}
              />
            </div>

            {showMonthYearPicker
              ? <div className={`${styles.filterDateInput} ${styles.filterDateMonthly}`}>
                <button
                  type="button"
                  className={`${styles.btnAddTable} ${styles.btnToggleCalendar} ${showMonthYearPicker ? "" : styles.rotate}`}

                  onClick={() => setShowMonthYearPicker(!showMonthYearPicker)}
                >
                  <FaRetweet />
                </button>
                <MonthYearPicker
                  placeholder="Selecionar mensal"
                  onChange={(e) => handleOnChangeCalendarPeriod(e)}
                />

              </div>
              : <div className={styles.filterDateInput}>
                <button
                  type="button"
                  className={`${styles.btnAddTable} ${styles.btnToggleCalendar} ${showMonthYearPicker ? "" : styles.rotate}`}

                  onClick={() => setShowMonthYearPicker(!showMonthYearPicker)}
                >
                  <FaRetweet />
                </button>
                <DatePicker
                  change={handleOnChangeCalendarPeriod}
                  placeholder="Selecionar por período"
                  showClearButton={!!startDate && !!endDate}
                  onClearFields={handleClearPeriodFilter}
                  dateStart={startDate}
                  dateFinal={endDate}
                  range
                />
              </div>
            }



            <button
              type="button"
              className={styles.btnAddTable}
              onClick={() => loadOwnDeliveryReports()}
              disabled={!startDate || !endDate}
            >
              <FaCirclePlus fill="#fff" color="#fff" />
              <span>Gerar</span>
            </button>

            <button
              type="button"
              onClick={() => {
                const name = getNameOfReportFile();

                exportToExcel(
                  ownDeliveryReports,
                  name
                )
              }}
              className={styles.buttonDownload}
              disabled={!ownDeliveryReports?.length}
            >
              <FiDownload />
              <span>Baixar</span>
            </button>
          </div>
          <div className={styles.contentTable}>
            <table className={styles.tableContainer}>
              <thead>
                <tr>
                  <th width="10">Etiqueta</th>
                  {isNormal && <th width="9">Competência</th>}
                  <th width="9">ID</th>
                  {(isNormal || isValidated) && <th width="9">Envio</th>}
                  {(isNormal || isValidated) && <th width="9">Coleta</th>}
                  <th width="9">Pedido</th>
                  <th width="9">Valor</th>
                  <th width="9">Peso</th>
                  <th width="10">Cep</th>
                  <th width="9">Destinatario</th>
                  <th width="5">UF</th>
                  <th width="5%">Motorista</th>
                  {!isNormal && <th width="5%">Status</th>}
                  {!isNormal && <th width="5%"> <span style={{ display: "flex", width: "max-content" }}>{reportType === tableTypes.delivered ? "Data de entrega" : "Tentativa de entrega"}</span></th>}
                </tr>
              </thead>
              {!!displayImg &&
                <tbody>
                  <th colSpan={10} style={{ textAlign: 'center', padding: '40px' }}>
                    <img
                      src={imgOwnDeliveryReports}
                      alt="Imagem de uma figura feminina com uma caixa de seleção no fundo"
                      className={styles.imgOwnDeliveryReports}
                    />
                  </th>
                </tbody>}
              <tbody>
                {
                  !!displaySuperExpressItems?.length &&
                  displaySuperExpressItems?.map((row, index) => {
                    return (
                      <>
                        <tr key={row.ID}>
                          <td>{row?.Etiqueta ?? "--"}</td>
                          {isNormal && <td>{row?.Competência ?? "--"}</td>}
                          <td>{row?.ID ?? "--"}</td>
                          {(isNormal || isValidated) && <td>{row?.Envio ?? "--"}</td>}
                          {(isNormal || isValidated) && <td>{row?.Coleta ?? "--"}</td>}
                          <td>{row?.Pedido ?? "--"}</td>
                          <td>{row?.Valor ?? "--"}</td>
                          <td>{row?.Peso ?? "--"}</td>
                          <td>{row?.CEP ?? "--"}</td>
                          <td>{row?.Destinatário ?? "--"}</td>
                          <td>{row?.UF ?? "--"}</td>
                          <td><span>{row?.Motorista ?? "--"}</span></td>
                          {!isNormal && <td>{row?.Status ?? "--"}</td>}
                          {!isNormal && <td>{
                            reportType === tableTypes.delivered ?
                              (row['Data de Entrega'] ?? "--") :
                              (row['Tentativa de Entrega'] ?? "--")
                          }</td>}
                        </tr>
                        {
                          index === (displaySuperExpressItems?.length - 1) &&
                          <tr>
                            <td colSpan={10} style={{ textAlign: 'center', fontSize: "14px" }}>{"A tabela exibe apenas uma amostra dos dados. Clique em 'Baixar relatório' para ver o completo."}</td>
                          </tr>
                        }
                      </>
                    );
                  })
                }
              </tbody>
              {
                !displayImg && !displaySuperExpressItems?.length &&
                <tbody>
                  <th colSpan={10} style={{ textAlign: 'center', padding: '40px' }}>
                    <h4>Não foram encontrados resultados para essa pequisa.</h4>
                  </th>
                </tbody>
              }
            </table>
          </div>
        </div>
      </Container>
    </>
  )
}

export { OwnDeliveryReports };
